<template>
  <b-form>
    <b-form-group label="Название">
      <b-form-input v-model="model.title" @change="sync()"></b-form-input>
    </b-form-group>
    <b-form-group label="Ссылка">
      <b-form-input v-model="model.url" @change="sync()" @input="parseURL"></b-form-input>
    </b-form-group>
    <b-alert :show="!!error" variant="danger">{{ error }}</b-alert>
    <div v-if="model.valid" class="preview" v-html="preview"></div>
  </b-form>
</template>

<script>
import debounce from 'lodash/debounce'
import axios from 'axios'

export default {
  name: 'VideoForm',
  model: {
    prop: 'video',
    event: 'sync'
  },
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    model: {
      id: null,
      valid: false,
      title: '',
      url: ''
    },
    error: '',
    preview: ''
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.model = this.video
    },
    sync () {
      this.$emit('sync', this.model)
    },
    parseURL: debounce(function () {
      // if (!this.model.url) {
      //   return
      // }
      axios.get('https://noembed.com/embed?url=' + this.model.url)
        .then(response => {
          if (response.data.error) {
            this.model.valid = false
            this.preview = ''
            this.error = response.data.error
          } else {
            this.model.valid = true
            this.preview = response.data.html
            this.error = ''

            this.$nextTick(() => {
              window.FB.XFBML.parse()
            })

            if (!this.model.title) {
              this.model.title = response.data.title
            }
          }
        })
    }, 300)
  }
}
</script>
